import * as moment from "moment";
import { FeesRepo } from "@services/fees.repo";
import { NavFeesSummaryData } from "@models/dashboard/DashboardTables";
import { extractErrorMessage } from "@common/utils/errorUtils";
import { Column } from "@models/dashboard/DashboardTables";

class NavFeesSummaryController {
  public data: NavFeesSummaryData[] = [];
  public isDaily: boolean = false;
  public fromDate;
  public toDate;
  public currentDate;
  public minDate; // 12 months ago - minimum selectable date
  public lastMonth;
  public isLoading: boolean = false;

  public columns: Column[] = [
    { key: 'dataGrouping', label: 'Date'},
    { key: 'noOfPortfolios', label: 'No. Of Portfolios', type: 'number' },
    { key: 'totalNav', label: 'Total NAV (MUR)', type: 'currency', currency: 'MUR' },
    { key: 'navDelta', label: 'NAV Delta (%)', type: 'percentage' },
    { key: 'totalFees', label: 'Total Fees (MUR)', type: 'currency', currency: 'MUR' },
    { key: 'feeDelta', label: 'Fee Delta (%)', type: 'percentage' },
    { key: 'feesUsd', label: 'Fees (USD)', type: 'currency', currency: 'USD' },
    { key: 'feesEur', label: 'Fees (EUR)', type: 'currency', currency: 'EUR' },
    { key: 'feesChf', label: 'Fees (CHF)', type: 'currency', currency: 'CHF' },
    { key: 'feesGbp', label: 'Fees (GBP)', type: 'currency', currency: 'GBP' },
    { key: 'feesMur', label: 'Fees (MUR)', type: 'currency', currency: 'MUR' },
  ];

  /** @ngInject */
  constructor(private $scope: angular.IScope,
          private feesRepo: FeesRepo,
          private $window: angular.IWindowService,
          private notifyjs: any) {

    this.currentDate = new Date();
    this.minDate = new Date(moment(this.currentDate).subtract(12, "months").startOf("month").format("YYYY-MM-DD"));
    this.fromDate = new Date(moment(this.currentDate).subtract(6, "months").startOf("month").format("YYYY-MM-DD"));
    this.toDate = new Date(moment(this.currentDate).subtract(1, "months").endOf("month").format("YYYY-MM-DD"));
    this.clampDatesToMinRange();
    this.refreshData();
  }

  formatDate(selectedDate) {
    return moment(selectedDate).format("YYYY-MM");
  }

  private clampDatesToMinRange() {
    if (this.minDate && this.fromDate && moment(this.fromDate).isBefore(moment(this.minDate))) {
      this.fromDate = new Date(this.minDate.getTime());
    }
    if (this.minDate && this.toDate && moment(this.toDate).isBefore(moment(this.minDate))) {
      this.toDate = new Date(this.fromDate.getTime());
    }
  }

  refreshData() {
    this.isLoading = true;
    let fromDate = moment(this.fromDate).startOf("month").format("YYYY-MM-DD");
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");

    if (this.isDaily) {
      fromDate = moment(this.fromDate).format("YYYY-MM-DD");
      toDate = moment(this.toDate).format("YYYY-MM-DD");
    }

    this.feesRepo.getNavFeesSummary(fromDate, toDate, this.isDaily).then((response: any) => {
      this.data = response.data;
    }).catch((err) => {
      this.notifyjs("Failed to load NAV fees summary " + extractErrorMessage(err));
    }).finally(() => {
      this.isLoading = false;
    });
  }

  getAuditExcel = () => {
    this.isLoading = true;

    let fromDate = moment(this.fromDate).startOf("month").format("YYYY-MM-DD");
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");

    if (this.isDaily) {
      fromDate = moment(this.fromDate).format("YYYY-MM-DD");
      toDate = moment(this.toDate).format("YYYY-MM-DD");
    }

    this.feesRepo
      .getAuditExcel(fromDate, toDate, this.isDaily)
      .then((res) => {
        let auditExcel = res.data as any;
        this.$window.open(auditExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to generate audit excel " + err.data
        );
      }).finally(() => {
        this.isLoading = false;
      });
  };

  getSummaryExcel = () => {
    this.isLoading = true;

    let fromDate = moment(this.fromDate).startOf("month").format("YYYY-MM-DD");
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");

    if (this.isDaily) {
      fromDate = moment(this.fromDate).format("YYYY-MM-DD");
      toDate = moment(this.toDate).format("YYYY-MM-DD");
    }

    this.feesRepo
      .getNavFeesSummaryFile(fromDate, toDate, this.isDaily)
      .then((res) => {
        let summaryExcel = res.data as any;
        this.$window.open(summaryExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to generate summary excel " + err.data
        );
      }).finally(() => {
        this.isLoading = false;
      });
  };
}

export const navFeesSummary: angular.IComponentOptions = {
  template: require("./nav-fees-summary.html"),
  controller: NavFeesSummaryController,
  bindings: {
    // Add bindings here as needed
    // Example:
    // selectedCurrency: "<",
    // lastMonth: "<",
  },
};




// WEBPACK FOOTER //
// ./src/app/fees/fees-components/nav-fees-summary/nav-fees-summary.ts